import { SxProps, Theme } from "@mui/material/styles";
import { HEADER_HEIGHT, MAX_WIDTH, SIDE_PADDING } from "../../theme/consts";
import { generalSectionSx } from "../../components/Layout";

// Scroll container - provides scroll space for animations
// Uses svh (small viewport height) for stable sizing on mobile
export const scrollContainerSx: SxProps<Theme> = {
  height: { xs: "220svh", xl: "200svh" },
  position: "relative",
};

// Sticky container - 100vh, contains Hero and AboutCledar
// Uses svh for stable sizing that doesn't change with mobile address bar
export const stickyContainerSx: SxProps<Theme> = {
  position: "sticky",
  top: 0,
  height: "100svh",
  boxSizing: "border-box",
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
  gap: "1.5rem",
  overflow: "hidden",
  ...generalSectionSx,
};
